
export { default as WorkplaceAddressFactory } from './workplaceAddress.factory';